import { useSearchParams } from "react-router-dom";
import VerifyEmail from "./verifyEmail";
import ResetPassword from "./resetPassword";
import PageNotFound from "./page_not_found";

const HandleUserAuth = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");

  // Modes
  // resetPassword
  // recoverEmail
  // verifyEmail
  if (mode === "verifyEmail") {
    return <VerifyEmail />;
  }
  if (mode === "resetPassword") {
    return <ResetPassword />;
  }
  return <PageNotFound />;
};

export default HandleUserAuth;
